import type { RepresentativeModel } from '../app/types/representative.type.ts';
import type { StaffMemberModel } from '../app/types/staff-member.type.ts';
import type { EmailExistsModel, UserListModel, UserModel } from '../app/types/user-type.ts';
import baseApi, { CacheTag } from './meeting-md-api-slice';

const userApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchLoggedInUser: builder.query<StaffMemberModel | UserModel | RepresentativeModel, void>({
      query: () => ({ url: `/User/LoggedIn/` }),
      providesTags: [CacheTag.CurrentUser],
    }),
    fetchEmailExists: builder.query<EmailExistsModel, string>({
      query: email => ({ url: `/User/EmailExists`, params: { email: email } }),
    }),
    postUser: builder.mutation<UserModel, UserModel>({
      query: post => ({
        url: '/User',
        method: 'POST',
        body: post,
      }),
      invalidatesTags: [CacheTag.User],
    }),
    putUser: builder.mutation<UserModel, UserModel>({
      query: put => ({
        url: `/User`,
        method: 'PUT',
        body: put,
      }),
      invalidatesTags: [CacheTag.User, CacheTag.CurrentUser],
    }),
    searchAdminUsers: builder.query<UserListModel[], string>({
      query: keyword => ({ url: `/User/Search${keyword ? `?keyword=${keyword}` : ''}` }),
      providesTags: [CacheTag.User],
    }),
    deleteUser: builder.mutation<void, string>({
      query: key => ({
        url: `/User/${key}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CacheTag.User],
    }),
    updateEmail: builder.mutation<void, UserListModel | UserModel>({
      query: user => ({
        url: '/User/ChangeEmail',
        method: 'PATCH',
        body: user,
      }),
      invalidatesTags: [CacheTag.User, CacheTag.CurrentUser],
    }),
  }),
});

export const {
  useFetchLoggedInUserQuery,
  useFetchEmailExistsQuery,
  usePostUserMutation,
  usePutUserMutation,
  useSearchAdminUsersQuery,
  useDeleteUserMutation,
  useUpdateEmailMutation,
  endpoints: userApiEndpoints,
} = userApi;
